import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import LandingPage from 'pages/Landing';
import LoginPage from 'pages/external/Login';
import SignupPage from 'pages/external/Signup';
import MyOperationsPage from 'pages/customer/MyOperations';
import BankAccountsPage from 'pages/customer/BankAccounts';
import ClaimPage from 'pages/customer/Claim';
import ProfilePage from 'pages/customer/Profile';
import CreateOperationPage from 'pages/customer/CreateOperation';
import ConfirmOperationPage from 'pages/customer/ConfirmOperation';
import CompanyOperationsPage from 'pages/customer/CompanyOperations';
import UsersPage from 'pages/customer/Users';

import { ProvideAuth } from 'contexts/Auth';
import AdminLoginPage from 'pages/external/AdminLogin';
import CustomersPage from 'pages/admin/customers';
import OperationsPage from 'pages/admin/operations';
import SignedPage from 'pages/admin/signed';
import VouchersPage from 'pages/admin/vouchers';
import ChangePage from 'pages/admin/change';
import RangesPage from 'pages/admin/Ranges';
import BanksPage from 'pages/admin/Banks';
import SeriesPage from 'pages/admin/Series';
import OperatorsPage from 'pages/admin/Operators';
import OperationsReportPage from 'pages/admin/operationsReport';
import ClaimsPage from 'pages/admin/claims';
import PromosPage from 'pages/admin/Promos';
import BulkMailPage from 'pages/admin/bulkMail';
import AdminLandingPage from 'pages/admin/landing';
import EmptyPage from 'pages/admin/empty';
import GraphsPage from 'pages/admin/graphs';
import DocumentPage from 'pages/external/Document';

function App() {
  return (
    <>
      <ProvideAuth>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/document/:documentName" element={<DocumentPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/my_operations" element={<MyOperationsPage />} />
            <Route path="/create_operation" element={<CreateOperationPage />} />
            <Route path="/operation/:id" element={<ConfirmOperationPage />} />
            <Route path="/bank_accounts" element={<BankAccountsPage />} />
            <Route path="/claim" element={<ClaimPage />} />
            <Route path="/profile" element={<ProfilePage />} />

            <Route path="/company_operations" element={<CompanyOperationsPage />} />
            <Route path="/users" element={<UsersPage />} />
          </Routes>
        </Router>
      </ProvideAuth>
      <ProvideAuth prefix="admin">
        <Router basename="admin">
          <Routes>
            <Route path="/" element={<Navigate to="/customers" />} />
            <Route path="/login" element={<AdminLoginPage />} />

            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/operations" element={<OperationsPage />} />
            <Route path="/signed" element={<SignedPage />} />
            <Route path="/vouchers" element={<VouchersPage />} />

            <Route path="/change" element={<ChangePage />} />
            <Route path="/ranges" element={<RangesPage />} />

            <Route path="/banks" element={<BanksPage />} />
            <Route path="/series" element={<SeriesPage />} />
            <Route path="/operators" element={<OperatorsPage />} />

            <Route path="/reports" element={<OperationsReportPage />} />
            <Route path="/graphs" element={<GraphsPage />} />
            <Route path="/claims" element={<ClaimsPage />} />

            <Route path="/promos" element={<PromosPage />} />
            <Route path="/mailer" element={<BulkMailPage />} />
            <Route path="/landing" element={<AdminLandingPage />} />

            <Route path="*" element={<EmptyPage />} />
          </Routes>
        </Router>
      </ProvideAuth>
      <div
        id="toast-container"
        className="fixed bottom-0 left-0 right-0 z-50 sm:bottom-auto sm:left-auto sm:top-20 sm:right-4"
      ></div>
      <meta name="enviroment" content={process.env.REACT_APP_ENVIROMENT} />
    </>
  );
}

export default App;
